import React from "react";
import { useState,useEffect } from "react";
import { Helmet } from 'react-helmet';
import './classes/LookingForAgentView.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const LookingForAgentView = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [noData, setNoData] = useState(false);

        const location = useLocation();
        const drupal_uid = localStorage.getItem('drupal_uid');
        const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
        var loggedin_domain = drupal_domain_url;
        if(localStorage.getItem('loggedin_domain')) {
        loggedin_domain = localStorage.getItem('loggedin_domain');
        } 
        const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
        const {id} = useParams();
        const [detailedview, setDetailedView] = useState(true);
        const [athletePicture, setAthletePicture] = useState({});
        const [submittedby, setSubmittedby] = useState({});
        const [nextId, setNextId] = useState({});
        const [prevId, setPrevId] = useState({});
        const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);

        // const {tab} = useParams();
        function updateToggle(aid) {
          setToggle(aid);
        
          if (aid === 1) {
            navigate(`/node/1080/submission/${id}`);
          }
        
          if (aid === 2) {
            navigate(`/node/1080/submission/${id}/edit`);
          }
           if (aid === 3) {
            navigate(`/node/1080/submission/${id}/delete`);
          }
        }
        
        const [toggle, setToggle] = useState(1);
        const loggedin_uid = localStorage.getItem('uid');
        const navigate = useNavigate();
        const app_url = configData.APP_URL;
        const domain_url = configData.DOMAIN_URL;
        
        useEffect(() => {
            Promise.all([
            retrievelookingforagentview(),
            retrieveUserLoggedinroles()
                
            ])
            .then(() => {
        
            setIsLoading(false);
            })
        
        },[]);

    async function retrieveUserLoggedinroles() {
        try {
            setIsLoading(true);
            const response = await fetch(
            app_url+'viewprofile/getuserloggedinrolesid',
            {
                method: "GET",
                headers: {
                'Content-Type': 'application/json',
                },
            }
            )
            const responsedata = await response.json();
            if(responsedata.data.result === "Success") {
            setUserLoggedInRoles(responsedata.data.roles)
            }
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
                
        }
    }
    
    async function  retrievelookingforagentview() {
        try {
        const response = await fetch(
        app_url+'smwwathlete/lookingforagentviewdetails?id='+id,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata?.data?.msg == "Success") {
            setDetailedView(responsedata.data.result);
            setAthletePicture(responsedata.data.picture);
            setNextId(responsedata.data.next_id);
            setPrevId(responsedata.data.prev_id);
            setSubmittedby(responsedata.data.submitted_by);
        } else {setNoData(true);}        
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
           setIsLoading(false);     
        }
    }
    const Section = ({ title, data, backendData }) => {
        if (!data || !backendData) return null;

        return (
            <div style={{ marginBottom: "20px" }}>
            {/* <h2>{title}</h2> */}
            {Object.entries(data).map(([key, { label, value }]) => (
                <div key={key} style={{ marginBottom: "5px" }}>
                <div style={{marginTop: "10px"}}><strong>{label || key}</strong></div> 
                <div>{backendData[value]}</div>
                </div>
            ))}
            </div>
        );
    };
    // const Section = ({ title, data, backendData }) => {
    // if (!data || !backendData) return null;

    // const renderValue = (val) => {
    //     if (val === null || val === undefined || val === "") {
    //     return "-";
    //     }

    //     if (typeof val === "object") {
    //     // If it's an array
    //     if (Array.isArray(val)) {
    //         return val.length ? val.join(", ") : "-";
    //     }

    //     // If it's an object
    //     return "-"; // or JSON.stringify(val) for debugging
    //     }

    //     return val;
    // };

    // return (
    //     <div style={{ marginBottom: "20px" }}>
    //     {Object.entries(data).map(([key, { label, value }]) => {
    //         const fieldValue = backendData?.[value];

    //         return (
    //         <div key={key} style={{ marginBottom: "5px" }}>
    //             <div style={{ marginTop: "10px" }}>
    //             <strong>{label || key}</strong>
    //             </div>
    //             <div>{renderValue(fieldValue)}</div>
    //         </div>
    //         );
    //     })}
    //     </div>
    // );
    // };

    const fieldData = {
        first_name: { label: "First Name", value: "first_name" },
        last_name: { label: "Last Name", value: "last_name" },
        street_address: { label: "Street Address", value: "street_address" },
        address_cont: { label: "Address (cont)", value: "address_cont" },
        city_town_province: { label: "City / Town / Province", value: "city_town_province" },
        state: { label: "State", value: "state" },
        zip_post_code: { label: "Zip/Post Code", value: "zip_post_code" },
        country: { label: "Country", value: "country" },
        phone: { label: "Phone", value: "phone" },
        email: { label: "Email", value: "email" },
        retype_email: { label: "Retype Email", value: "retype_email" },
        sport_played: { label: "Sport Played", value: "sport_played" },
        specific_sport: { label: "Specific Sport", value: "specific_sport" },
        positions_played: { label: "Primary Position", value: "positions_played" },
        university_attended: { label: "University Attended", value: "university_attended" },
        high_school: { label: "High School", value: "high_school" },
        high_school_city: { label: "High School City", value: "high_school_city" },
        high_school_state: { label: "High School State", value: "high_school_state" },
        awards: { label: "Awards", value: "awards" },
        professional_experience: { label: "Have you played for a professional team or academy? If so, which was your most recent one?", value: "professional_experience" },
        test_info: { label: "Test Info (40 time, 60 time, arm speed etc.)", value: "test_info"},
        date_of_birth: { label: "Date Of Birth", value: "date_of_birth"},
    };

    const heightInfo = {
        height: { label: " ", value: "height" },
        ft: { label: "Ft ", value: "ft" },
        in: { label: "In", value: "in" },
        height_unit: { label: " ", value: "height_unit" },
    }

    const heightInfoMetric = {
        height: { label: " ", value: "height" },
        height_unit: { label: " ", value: "height_unit" },
    }

    const weightInfo = {
        weight: { label: "Weight ", value: "weight" },
        weight_unit: { label: " ", value: "weight_unit" },
    }

    const socialMediaInfo = {
        facebook_url: { label: "Facebook URL", value: "facebook_url" },
        facebook_followers: { label: "Facebook Followers #", value: "facebook_followers" },
        instagram_url: { label: "Instagram URL", value: "instagram_url" },
        instagram_followers: { label: "Instagram Followers #", value: "instagram_followers" },
        your_linkedin_url: { label: "LinkedIn URL", value: "your_linkedin_url" },
        linkedin_followers: { label: "LinkedIn Followers #", value: "linkedin_followers" },
        tiktok_url: { label: "TikTok URL", value: "tiktok_url" },
        tiktok_followers: { label: "TikTok Followers #", value: "tiktok_followers" },
        twitter_url: { label: "Twitter URL", value: "twitter_url" },
        twitter_followers: { label: "Twitter Followers #", value: "twitter_followers" },
        youtube_url: { label: "YouTube URL", value: "youtube_url" },
        youtube_followers: { label: "YouTube Followers #", value: "youtube_followers" },
    }
   
    const FirstRefData = {
        "1st_reference_name": { label: "First Name", value: "1st_reference_name" },
        "1st_reference_last_name": { label: "Last Name", value: "1st_reference_last_name" },
        job_title_1: { label: "Job title (coach, scout, etc.)", value: "job_title_1" },
        team_or_club_1: { label: "Team or club", value: "team_or_club_1" },
        email_address_1: { label: "Email Address", value: "email_address_1" },
        "1st_reference_phone": { label: "Phone", value: "1st_reference_phone" },
    }
    const SecondRefData = {
        "2nd_reference_name": { label: "First Name", value: "2nd_reference_name" },
        "2nd_reference_last_name": { label: "Last Name", value: "2nd_reference_last_name" },
        job_title_2: { label: "Job title (coach, scout, etc.)", value: "job_title_2" },
        team_or_club_2: { label: "Team or club", value: "team_or_club_2" },
        email_address_2: { label: "Email Address", value: "email_address_2" },
        "2nd_reference_phone": { label: "Phone", value: "2nd_reference_phone" },
    }
    const ThirdRefData = {
        "3rd_reference_name": { label: "First Name", value: "3rd_reference_name" },
        "3rd_reference_last_name": { label: "Last Name", value: "3rd_reference_last_name" },
        job_title_3: { label: "Job title (coach, scout, etc.)", value: "job_title_3" },
        team_or_club_3: { label: "Team or club", value: "team_or_club_3" },
        email_address_3: { label: "Email Address", value: "email_address_3" },
        "3rd_reference_phone": { label: "Phone", value: "3rd_reference_phone" },
    }

  return (
     <>
         {isLoading ? (
              <Loading />
            ) : (
                <div id="main">
                    {noData ? (<p>No Data found</p>) : (
                    <>
                    <Helmet>
                        <title>{`Submission #${detailedview.id}`}</title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                            <ul className="tabs primarya">
                                <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>View</a></li>
                                {/* {userRoles.includes(configData.ROLE_AGENT) && ( */}
                                {userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) && 
                                <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit</a></li>}
                                <li className= {toggle === 3? "active" : ""} onClick={()=> updateToggle(3)}><a>Delete</a></li>
                                {/* )} */}
                            </ul>
                        }
                        <div className="lookingforagent-view-container">
                            {/* Top Navigation */}
                            <nav>
                                {prevId &&
                                    <a href={"/node/1080/submission/"+prevId}>Previous submission</a>
                                }
                                {nextId &&
                                    <a href={"/node/1080/submission/"+nextId}>Next submission</a>
                                }
                            </nav>
                            <div style={{clear:"both"}}></div>
                            <div>
                                {/* Submission Info */}
                                <fieldset className="submission-info" style={{padding:"10px"}}>
                                <legend>Submission information</legend>

                                <div className="user-picture">
                                    <a href={"/user/"+detailedview.uid+"/view"} title="View user profile.">
                                    <img
                                        src={athletePicture}
                                        alt="User profile"
                                    />
                                    </a>
                                </div>
                                    <div>Form: <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/lookingforagent.php"}>Looking for agent</a></div>
                                    <div>Submitted by <span><a href={"/user/"+detailedview.uid+"/view"}>{submittedby}</a></span></div>
                                    <div>{detailedview.created}</div>
                                    <div>{detailedview.ip_address}</div>
                                </fieldset>
                            </div>
                            <Section 
                                data={fieldData} 
                                backendData={detailedview} 
                            />
                            <fieldset>
                                <legend>Height</legend>
                            {detailedview.height === null ? (
                                    <Section 
                                        data={heightInfo} 
                                        backendData={detailedview} 
                                    />
                            ) : (
                                <>
                                    <div><strong>Cm</strong></div>
                                    <Section 
                                        data={heightInfoMetric} 
                                        backendData={detailedview} 
                                    />
                                </>
                            )}
                            </fieldset>
                            <Section 
                                data={weightInfo} 
                                backendData={detailedview} 
                            />
                            <Section 
                                data={socialMediaInfo} 
                                backendData={detailedview} 
                            />
                            <fieldset>
                                <legend>1st reference</legend>
                                <Section 
                                    data={FirstRefData} 
                                    backendData={detailedview} 
                                />
                            </fieldset>
                            <fieldset>
                                <legend>2nd reference (optional)</legend>
                                <Section 
                                    data={SecondRefData} 
                                    backendData={detailedview} 
                                />
                            </fieldset>
                            <fieldset>
                                <legend>3rd reference (optional)</legend>
                                <Section 
                                    data={ThirdRefData} 
                                    backendData={detailedview} 
                                />
                            </fieldset>
                            {/* Bottom Navigation */}
                            <nav>
                                {prevId &&
                                    <a href={"/node/1080/submission/"+prevId}>Previous submission</a>
                                }
                                {nextId &&
                                    <a href={"/node/1080/submission/"+nextId}>Next submission</a>
                                }
                            </nav>
                        </div>
                    </div>
                    <div className="right">
                        {/* {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) ? 
                            ( */}
                            <SalespersonSidebar/>
                            {/* ) : (
                            <>
                            <h1>Quick Links</h1>    
                            <ul className="user-opt-menu" style={{paddingLeft:"0px"}}>       
                                <li className='agent-header-hello-text'><a href={"/user/"+loggedin_drupal_uid+"/edit"} className="agent-quick_link_anchor">Manage My Profile</a></li>
                                <li>
                                <a href="/smww_pay">
                                    <input type="button" className='agent-quick-links-reg-button' value="Register for a Course"/>
                                </a>
                                </li>
                            </ul>  
                            </>
                        )}  */}
                    </div>
                    </>)}
                </div>
            )}
        </>
    );
};

export default LookingForAgentView;